var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2851 0.714886C14.5754 0.00513461 13.4246 0.00513455 12.7149 0.714886L1.14885 12.2809C0.4391 12.9907 0.4391 14.1414 1.14885 14.8512C1.8586 15.5609 3.00933 15.5609 3.71908 14.8512L14 4.57023L24.2809 14.8512C24.9907 15.5609 26.1414 15.5609 26.8512 14.8512C27.5609 14.1414 27.5609 12.9907 26.8512 12.2809L15.2851 0.714886ZM15.8174 30L15.8174 2L12.1826 2L12.1826 30L15.8174 30Z",
    fill: "#0075FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.6113ec7f4b56228ca89a3a26dffe4189.svg";
export { ForwardRef as ReactComponent };